export class RecouvrementVegetal {
    PourcentTotal: number;
    PourcentBryophytes: number;
    PourcentAlgues: number;

    static mapFromJSON(json): RecouvrementVegetal {
        const r = new RecouvrementVegetal();

        r.PourcentAlgues = json.pourcentAlgues;
        r.PourcentBryophytes = json.pourcentBryophytes;
        r.PourcentTotal = json.pourcentTotal;

        return r;
    }
}

